<div class="modal-backdrop" (click)="cerrarModal()">
  <div class="modal-card" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="modal-header">
      <div class="header-titulos">
        <h4>Administración de Usuarios</h4>
        <h6>Editar información y reenviar correo de acceso</h6>
      </div>
      <button type="button" class="btn-cerrar" (click)="cerrarModal()" [disabled]="cargando" aria-label="Cerrar modal">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <!-- Body / Form -->
    <form [formGroup]="form" (ngSubmit)="editarUsuario()" class="modal-form">
      <div class="form-grid">
        <!-- Nombres -->
        <div class="campo">
          <label for="nombres">Nombres <span class="requerido">*</span></label>
          <input 
            id="nombres" 
            type="text" 
            formControlName="nombres" 
            placeholder="Nombres del usuario"
            [class.invalido]="form.get('nombres').invalid && form.get('nombres').touched"
          />
          <span class="error-msg" *ngIf="form.get('nombres').invalid && form.get('nombres').touched">
            El nombre es obligatorio.
          </span>
        </div>

        <!-- Apellidos -->
        <div class="campo">
          <label for="apellidos">Apellidos <span class="requerido">*</span></label>
          <input 
            id="apellidos" 
            type="text" 
            formControlName="apellidos" 
            placeholder="Apellidos del usuario"
            [class.invalido]="form.get('apellidos').invalid && form.get('apellidos').touched"
          />
          <span class="error-msg" *ngIf="form.get('apellidos').invalid && form.get('apellidos').touched">
            El apellido es obligatorio.
          </span>
        </div>

        <!-- Tipo Documento -->
        <div class="campo">
          <label for="tipoDocumento">Tipo de Documento <span class="requerido">*</span></label>
          <select id="tipoDocumento" formControlName="tipoDocumento">
            <option *ngFor="let tipo of tiposDocumento" [value]="tipo">{{ tipo }}</option>
          </select>
        </div>

        <!-- No. Documento -->
        <div class="campo">
          <label for="numeroDocumento">Número de Documento <span class="requerido">*</span></label>
          <input 
            id="numeroDocumento" 
            type="text" 
            formControlName="numeroDocumento" 
            placeholder="Ej: 1020304050"
            [class.invalido]="form.get('numeroDocumento').invalid && form.get('numeroDocumento').touched"
          />
          <span class="error-msg" *ngIf="form.get('numeroDocumento').invalid && form.get('numeroDocumento').touched">
            El número de documento es obligatorio.
          </span>
        </div>

        <!-- Correo Electrónico -->
        <div class="campo campo-full">
          <label for="correo">Correo Electrónico</label>
          <input 
            id="correo" 
            type="email" 
            formControlName="correo" 
            placeholder="ejemplo@correo.com"
            readonly
          />
        </div>

        <!-- Celular con Indicativo -->
        <div class="campo campo-telefono">
          <label for="celular">Teléfono / Celular <span class="requerido">*</span></label>
          <div class="telefono-inputs">
            <input 
              id="indicativo" 
              type="text" 
              class="input-indicativo" 
              formControlName="indicativo" 
              placeholder="+57"
            />
            <input 
              id="celular" 
              type="text" 
              class="input-celular" 
              formControlName="celular" 
              placeholder="Ej: 3001234567"
              [class.invalido]="form.get('celular').invalid && form.get('celular').touched"
            />
          </div>
          <span class="error-msg" *ngIf="form.get('celular').invalid && form.get('celular').touched">
            El teléfono es obligatorio.
          </span>
        </div>

        <!-- Lugar Asignado -->
        <div class="campo">
          <label for="lugar">Lugar Asignado / Unidad</label>
          <input 
            id="lugar" 
            type="text" 
            formControlName="lugar" 
            placeholder="Lugar o apartamento asignado"
          />
        </div>
      </div>

      <!-- Estado actual de envío -->
      <div class="estado-info" *ngIf="usuario?.estado_legible">
        <span class="estado-label">Estado actual de correo:</span>
        <span class="estado-valor">{{ usuario.estado_legible }}</span>
      </div>

      <!-- Footer / Botones -->
      <div class="modal-footer">
        <button type="button" class="btn-cancelar" (click)="cerrarModal()" [disabled]="cargando">
          Cancelar
        </button>
        <button type="button" class="btn-reenviar" (click)="reenviarCorreo()" [disabled]="cargando || form.invalid">
          <mat-spinner *ngIf="cargandoReenviar" [diameter]="18"></mat-spinner>
          <mat-icon *ngIf="!cargandoReenviar">email</mat-icon>
          <span>{{ cargandoReenviar ? 'Reenviando...' : 'Reenviar correo' }}</span>
        </button>
        <button type="submit" class="btn-editar" [disabled]="cargando || form.invalid">
          <mat-spinner *ngIf="cargandoEditar" [diameter]="18"></mat-spinner>
          <mat-icon *ngIf="!cargandoEditar">save</mat-icon>
          <span>{{ cargandoEditar ? 'Guardando...' : 'Guardar' }}</span>
        </button>
      </div>
    </form>
  </div>
</div>
